import React from 'react';

import '../styles.css';
import { Button, Image, Modal } from 'react-bootstrap';
import { formatAmount } from '../../../utils';
import Gold from '../../../assets/images/gold-icon.jpg';
import Palladium from '../../../assets/images/palladium-icon.jpg';
import Platinum from '../../../assets/images/platinum-icon.jpg';
import Silver from '../../../assets/images/silver-icon.jpg';

interface PropsType {
  handleModal: any;
  isShow: boolean;
  data: any;
  onProceedPayment: any;
  minutes: number;
  seconds: number;
  OrderPayMethod?: any;
}

const OrderConfirmation: React.FC<PropsType> = ({
  handleModal,
  isShow,
  data,
  onProceedPayment,
  minutes,
  seconds,
  OrderPayMethod,
}) => {
  const getMetalName = (code) => {
    switch (code) {
      case 'Ag':
        return 'Silver';
      case 'Au':
        return 'Gold';
      case 'Pt':
        return 'Platinum';
      case 'Pd':
        return 'Palladium';
    }
  };
  return (
    <>
      {data && (
        <>
          <Modal
            show={isShow}
            onHide={() => handleModal(false)}
            // bsPrefix='md__'
            dialogClassName='md__'
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {data?.type == 'BUYBACK'
                  ? 'Sell Confirmation'
                  : 'Order Confirmation'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='px-5'>
              <div className='row py-2 justify-content-around border-bottom'>
                <div className='col-md-6 mb-2 text-center'>
                  {data.items[0]?.itemBreakDown[0]?.metalCode === 'Au' && (
                    <Image
                      src={Gold}
                      roundedCircle
                      className='shadow'
                      width={80}
                      height={80}
                    ></Image>
                  )}
                  {data.items[0]?.itemBreakDown[0]?.metalCode === 'Ag' && (
                    <Image
                      src={Silver}
                      roundedCircle
                      className='shadow'
                      width={80}
                      height={80}
                    ></Image>
                  )}
                  {data.items[0]?.itemBreakDown[0]?.metalCode === 'Pt' && (
                    <Image
                      src={Platinum}
                      roundedCircle
                      className='shadow'
                      width={80}
                      height={80}
                    ></Image>
                  )}
                  {data.items[0]?.itemBreakDown[0]?.metalCode === 'Pd' && (
                    <Image
                      src={Palladium}
                      roundedCircle
                      className='shadow'
                      width={80}
                      height={80}
                    ></Image>
                  )}
                </div>
                <div className='col-md-6 mb-2 align-items-center text-start'>
                  <div>Selected Metal</div>
                  <h2>
                    {getMetalName(data.items[0]?.itemBreakDown[0]?.metalCode)}
                  </h2>
                </div>
              </div>
              <div className='row py-1 justify-content-between'>
                <div className='col-md-6 col-6 mb-1'>Rate</div>
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <b>
                    ₹{' '}
                    {formatAmount(
                      data.items[0]?.itemBreakDown[0].summary.unitPrice,
                      2
                    )}
                    /g
                  </b>
                </div>
              </div>
              <div className='row py-1 justify-content-between'>
                <div className='col-md-6 col-6 mb-1'>Quantity</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>{`${data.items[0]?.itemBreakDown[0].summary.originalQuantity.toFixed(
                    4
                  )} g`}</b>
                </div>
              </div>
              {data.items[0]?.itemBreakDown[0].summary.adjustedQuantity !==
                0 && (
                <div className='row py-1 justify-content-between'>
                  <div className='col-md-6 col-6 mb-1'>Product Discount</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>{`${data.items[0]?.itemBreakDown[0].summary.adjustedQuantity.toFixed(
                      4
                    )} g`}</b>
                  </div>
                </div>
              )}

              <div className='row py-1 justify-content-between'>
                <div className='col-md-6 col-6 mb-2'>Line Amount</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>
                    ₹ {formatAmount(data.items[0]?.summary.totalLineAmount)}
                  </b>
                </div>
              </div>
              {data.summary.itemTotalDiscount !== 0 && (
                <div className='row py-1 justify-content-between'>
                  <div className='col-md-6 col-3 mb-2'>Discount</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>- ₹ {formatAmount(data.summary.itemTotalDiscount)}</b>
                  </div>
                </div>
              )}
              {data.summary.itemTotalTax !== 0 && (
                <div className='row py-1 justify-content-between'>
                  <div className='col-md-6 col-6 mb-1'>Tax</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>₹ {formatAmount(data.summary.itemTotalTax)}</b>
                  </div>
                </div>
              )}
              {data.summary.quotationTax !== 0 && (
                <div className='row py-1 justify-content-between'>
                  <div className='col-md-6 col-6 mb-1'>
                    Other Charges and Taxes
                  </div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>₹ {formatAmount(data.summary.quotationTax)}</b>
                  </div>
                </div>
              )}
              {data.items[0].itemBreakDown[0].summary?.roundingDifference !==
                0 &&
              (data.items[0].itemBreakDown[0].summary?.roundingDifference > 0 ||
                data.items[0].itemBreakDown[0].summary?.roundingDifference <
                  0) ? (
                <div className='row py-1 justify-content-between'>
                  <div className='col-md-6 col-6 mb-1'>Rounding Difference</div>
                  {/* <div className='col-md-6 mb-2 text-end'> */}
                  <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                    <b>
                      {data.items.length > 0 &&
                      data.items[0].itemBreakDown.length > 0 &&
                      data.items[0].itemBreakDown[0].summary
                        ?.roundingDifference > 0
                        ? '₹ ' +
                          formatAmount(
                            data.items[0].itemBreakDown[0].summary
                              ?.roundingDifference
                          )
                        : '- ₹ ' +
                          formatAmount(
                            data.items[0].itemBreakDown[0].summary
                              ?.roundingDifference * -1
                          )}
                    </b>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {OrderPayMethod &&
                OrderPayMethod?.map((ord) => (
                  <>
                    <div className='row py-3 justify-content-between border-top'>
                      <div className='col-md-6 col-6 mb-1'>
                        {ord?.paymentMethod}
                      </div>
                      {/* <div className='col-md-6 mb-2 text-end'> */}
                      <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                        <b>₹ {ord?.amount}</b>
                      </div>
                    </div>
                  </>
                ))}
              <div className='row py-3 justify-content-between border-top'>
                <div className='col-md-6 col-6 mb-1'>Total</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>₹ {formatAmount(data.summary.quotationTotal)}</b>
                </div>
              </div>
              <div className='row justify-content-end mb-2'>
                <div className='col-md-12 text-end countdown-order-summary text-muted'>
                  Quotation refreshes in {minutes > 0 ? `${minutes}m ` : ``}
                  {`${seconds}s`}
                </div>
              </div>
              {data?.type == 'SELL' ? (
                <div className='disclaimer-text text-muted text-justify  my-2 '>
                  Disclaimer: The ownership of your metal will be confirmed with
                  a GST Tax invoice within three business days.
                </div>
              ) : null}

              <div className='d-grid py-3'>
                <Button
                  variant='primary'
                  className='btn-block'
                  onClick={onProceedPayment}
                  size='lg'
                >
                  {data?.type == 'BUYBACK' ? 'Sell' : 'Make Payment'}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default React.memo(OrderConfirmation);
